import type { TCompositionDeps } from "./types";
import { wireBusinessPartnersList } from "./wireBusinessPartnersList";
import { wireBusinessPartnerDeals } from "./wireBusinessPartnerDeals";
import { wireBusinessPartnerDetails } from "./wireBusinessPartnerDetails";

export const wireBusinessPartners = (deps: TCompositionDeps) => {
    const { ViewServiceProviders } = wireBusinessPartnersList(deps);
    const { ViewBusinessPartnerDeals } = wireBusinessPartnerDeals(deps);
    const { ViewBusinessPartnerDetails } = wireBusinessPartnerDetails(deps);

    return { ViewServiceProviders, ViewBusinessPartnerDeals, ViewBusinessPartnerDetails };
};
